import { ChevronDownIcon } from "@/assets/icons/ChevronDownIcon";
import { ChevronUpIcon } from "@/assets/icons/ChevronUpIcon";
import { Button, List, ListItem, Popover } from "@mui/material";
import classes from "./SelectOnePropertyDropdown.module.scss";
import clsx from "clsx";
import { useSelector } from "react-redux";
import { userListingsSelector } from "@/redux/selectors/userDataSelector";
import { SearchInput } from "@/views/common/DesktopHeader/components/SearchInput";
import { IListing } from "@/views/interfaces";
import { useEffect, useRef, useState } from "react";

export const SelectOnePropertyDropdown = ({
  anchorEl,
  selectedListing,
  onClose,
  onMenuOpen,
  onSelect,
}: {
  anchorEl: HTMLElement | null;
  selectedListing: IListing | null;
  onClose: VoidFunction;
  onMenuOpen: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onSelect: (listing: IListing) => VoidFunction;
}) => {
  const userListings = useSelector(userListingsSelector);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [popoverWidth, setPopoverWidth] = useState<number | undefined>(
    undefined
  );

  const searchQueryChangeHandler = ({
    target: { value },
  }: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(value);
  };

  useEffect(() => {
    if (buttonRef?.current) {
      setPopoverWidth(buttonRef.current.offsetWidth);
    }
  }, [anchorEl]);

  const isOpen = Boolean(anchorEl);
  const id = isOpen ? "simple-popover" : undefined;
  const icon = isOpen ? <ChevronUpIcon /> : <ChevronDownIcon />;

  const displayData = userListings?.filter((listing: IListing) =>
    listing.last_live_nick.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <>
      <Button
        id={id}
        endIcon={icon}
        color="secondary"
        className={clsx(classes.listingsButton, {
          [classes.expanded]: isOpen,
        })}
        onClick={onMenuOpen}
        ref={buttonRef}
      >
        {selectedListing
          ? selectedListing.last_live_nick
          : "Choose your listing"}
      </Button>
      <Popover
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        PaperProps={{
          className: classes.popoverPaper,
          style: { width: popoverWidth },
        }}
        className={classes.popover}
        id={id}
        open={isOpen}
        anchorEl={anchorEl}
        onClose={onClose}
      >
        <div className={classes.listingsContainer}>
          <SearchInput
            value={searchQuery}
            onChange={searchQueryChangeHandler}
          />
          <List className={classes.list}>
            <ListItem className={classes.totalItem}>
              Total: {displayData?.length}
            </ListItem>
            {displayData.map((listing: IListing) => (
              <ListItem
                className={classes.listItem}
                key={listing.property_id}
                onClick={onSelect(listing)}
              >
                {listing.last_live_nick}
              </ListItem>
            ))}
          </List>
        </div>
      </Popover>
    </>
  );
};
